<template>
   <div>
     <Headbar></Headbar>
     <div class='Box'>
       <div class="left" @click="leftClick">
         <img class="searchIcon" src="../../assets/search.png">
         <div class="text1">{{this.tableData.dsh}}个待审核</div>
         <div class="text2">订单发布审核</div>
       </div>
       <div class="right" @click="rightClick">
         <img class="lightIcon" src="../../assets/light.png">
         <div class="text1">{{this.tableData.ycdd}}个待处理</div>
         <div class="text2">异常订单处理</div>
       </div>      
    </div>
   </div>
    
</template>

<script>
import Headbar from '@/components/headbar'

export default {
    components:{
      Headbar
    },
    data(){
        return{
            tableData:[],
        }
    },
    computed: {

    },
    watch: {

    },
    mounted(){
        document.documentElement.scrollTop=0;
        this.handleAjax()
        if(this.$route.query.code&&this.$route.query.code==1){
            this.dialogVisible=!this.dialogVisible
        }

    },
    methods:{
        handleAjax(){
            this.ajax.post('/jyOder/count',{bizContent:{}})
                .then(
                    result=>{
                        if(result.data.status=='0000'){
                            let add = result.data.data
                            // console.log(add,'yyy')
                            this.tableData=add
                            // this.total=result.data.total
                            // if(this.radio2=='0'){
                            //     if(this.tableData.length==0){
                            //         this.showCon=false
                            //         //下面是修改后的代码，为了让表格显示出来
                            //         // this.showCon=true
                            //     }else{
                            //         this.showCon=true
                            //     }
                            // }
                            // this.loading=false
                        }else{
                            }
                        }
                )
        },

        handleRowClick(val){
            this.$router.push({
                name:'OrderDetail',
                query:{
                    // oid:val.orderId,
                    oId: val,
                    wendang: '背书超时订单-首次超时-详情',

                }
            })
        },
        leftClick(){
          this.$router.push({
                name:'WaitConfirm',
                query:{
                    // oid:val.orderId,
                    // oId: val,
                    // wendang: '背书超时订单-首次超时-详情',
                    sideNameId:'a',
                }
            })
        },
        rightClick(){
          this.$router.push({
                name:'FirstOvertime',
                query:{
                    // oid:val.orderId,
                    // oId: val,
                    // wendang: '背书超时订单-首次超时-详情',
                    sideNameId:'b',
                }
            })
        },
    }
}
</script>

<style  scoped>
.Box{
    width:1748px;
    height:773px;
    background:rgba(245,248,252,1);
    margin-left: 172px;
    margin-top: 90px;
    padding-top: 152px;
    padding-left: 411px;
    display: flex;
}

.left{
  width:337px;
  height:337px;
  background:rgba(255,255,255,1);
  box-shadow:0px 2px 15px 0px rgba(0,0,0,0.11);
  border-radius:10px;
  margin-right: 20px;
  text-align: center;
}

.text1{
  height:40px;
  font-size:28px;
  font-family:PingFangSC-Medium,PingFang SC;
  font-weight:500;
  color:rgba(59,66,80,1);
  line-height:40px;
}

.text2{
  height:28px;
  font-size:20px;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(102,102,102,1);
  line-height:28px;
}

.searchIcon{
  width: 90px;
  height: 80px;
  margin-top: 75px;
  margin-bottom: 45px;
}


.right{
  width:337px;
  height:337px;
  background:rgba(255,255,255,1);
  box-shadow:0px 2px 15px 0px rgba(0,0,0,0.11);
  border-radius:10px;
  text-align: center;
}

.lightIcon{
  width: 87px;
  height: 80px;
  margin-top: 70px;
  margin-bottom: 45px;
}

</style>


// WEBPACK FOOTER //
// src/page/orderexception/OrderHall.vue